<template>
  <div :class="['activity-item', data.color]">
    <div class="meta">
      <time>{{ data.clientDate }}</time>
      <h4 v-html="data.clientTitle"></h4>
      <!-- 內容文字 -->
      <div class="content" v-html="data.reason" v-if="!data.only_title"></div>
      <div class="content" v-if="data.sepc_reason">
        Title: {{ data.sepc_reason.title }}<br />
        Description : {{ data.sepc_reason.description }}
      </div>

      <!-- action -->
      <div
        class="a-go"
        v-if="showRequestUpdate"
        @click="$emit('request-update', data)"
      >
        Request new update
      </div>
      <div
        class="a-go"
        v-else-if="data.message_id"
        @click="$emit('view-message', data)"
      >
        View message
      </div>
    </div>

    <!-- 下層列表 -->
    <div class="act-other-list" v-if="data.activity_list?.length">
      <ActivityItem
        v-for="(child, idx) in data.activity_list"
        :key="idx"
        :data="child"
        :is_child="true"
        @request-update="$emit('request-update', $event)"
        @view-message="$emit('view-message', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import ActivityItem from './ActivityHistoryItem.vue';

const props = defineProps({
  data: { 
    type: Object, 
    required: true,
  },
  is_child: {
    type: Boolean,
    default: false
  }
})

const showRequestUpdate = computed(() => props.data.is_creator_responded === 1)
</script>